import produce from "immer";
import {
  SingleApplicationActionTypes,
  ApplicationDetailState,
  LOAD_SINGLE_APPLICATION_SUCCESS,
  RESET_SINGLE_APPLICATION,
  UPLOAD_DETAIL_FILE_SUCCESS,
  SET_APPLICATION_NOTES_SUCCESS,
  SET_WORK_INFORMATION_SUCCESS,
  SET_APPLICATION_FEEDBACK_SUCCESS,
  LOAD_EXISTING_APPLICATION_FEEDBACK_SUCCESS,
  DOWNLOAD_INSPECTION_REPORT_SUCCESS,
  DOWNLOAD_DEFECT_REPORT_SUCCESS,
  LOAD_AUDIT_LOGS_SUCCESS,
  RESET_AUDIT_LOGS,
  SET_PARTICIPANT_SUCCESS,
  SET_NOTIFY_WORK_START_SUCCESS,
  REPLACE_PARTICIPANT_SUCCESS,
  SET_NOTIFY_WORK_COMPLETION_SUCCESS,
  REMOVE_PARTICIPANT_SUCCESS,
  SET_LOCATION_SUCCESS,
  DELETE_ATTACHMENT_SUCCESS,
  CANCEL_APPLICATION_SUCCESS,
  SET_MAINTENANCE_COMPLETION_SUCCESS,
  DECLINE_APPLICATION_PARTICIPANT_SUCCESS,
  SET_TTM_STANDARD_SUCCESS
} from "./types";
import {
  processApplicationShapes,
  processRcaBoundaries,
  processDateFields,
  processInspectionsAndDefects,
  processApplicationFees,
  processParticipants,
  generateInspectionPdf,
  generateDefectPdf,
  processCertificateExpiry,
  handleWorkInformationUpdate,
  handleNotifyWorkStart,
  handleLoadAuditLogs,
  handleNotifyWorkCompletion,
  handleLocationUpdate,
  handleMaintenanceCompletion,
  handleReplaceParticipant,
  handleUploadDetailFile,
  handleDeleteAttachment
} from "./reducer-helpers";

const initialState: ApplicationDetailState = {
  applicationDetailData: undefined
};

const applicationDetailReducer = produce(
  (draft: ApplicationDetailState, action: SingleApplicationActionTypes) => {
    switch (action.type) {
      case LOAD_SINGLE_APPLICATION_SUCCESS: {
        draft.applicationDetailData = action.applicationDetailData;
        draft.applicationDetailData.isApplicationCancelled = false;

        processApplicationShapes(draft, action.applicationDetailData.shapes);
        processRcaBoundaries(draft, action.applicationDetailData.rcaBoundaries);
        processDateFields(draft);
        processInspectionsAndDefects(draft);
        processApplicationFees(draft);
        processParticipants(draft);

        return;
      }
      case RESET_SINGLE_APPLICATION: {
        draft.applicationDetailData = initialState.applicationDetailData;
        return;
      }
      case UPLOAD_DETAIL_FILE_SUCCESS: {
        handleUploadDetailFile(draft, action.attachments);
        return;
      }
      case SET_APPLICATION_NOTES_SUCCESS: {
        if (draft.applicationDetailData) {
          draft.applicationDetailData.notes = action.notes;
        }
        return;
      }
      case SET_WORK_INFORMATION_SUCCESS: {
        handleWorkInformationUpdate(draft, action.workInfo);
        return;
      }
      case SET_APPLICATION_FEEDBACK_SUCCESS: {
        draft.feedback = action.feedback;
        return;
      }
      case LOAD_EXISTING_APPLICATION_FEEDBACK_SUCCESS: {
        if (!action.feedback) {
          draft.feedback = undefined;
        } else {
          draft.feedback = action.feedback;
        }
        return;
      }
      case DOWNLOAD_INSPECTION_REPORT_SUCCESS: {
        generateInspectionPdf(action.inspection);
        return;
      }
      case DOWNLOAD_DEFECT_REPORT_SUCCESS: {
        generateDefectPdf(action.defect);
        return;
      }
      case SET_PARTICIPANT_SUCCESS: {
        processCertificateExpiry(action.participant);
        draft.applicationDetailData!.participants = [
          ...draft.applicationDetailData!.participants!,
          action.participant
        ];
        return;
      }
      case REPLACE_PARTICIPANT_SUCCESS: {
        handleReplaceParticipant(draft, action.participantResponse);
        return;
      }
      case SET_NOTIFY_WORK_START_SUCCESS: {
        handleNotifyWorkStart(draft, action.updatedInfo);
        return;
      }
      case LOAD_AUDIT_LOGS_SUCCESS: {
        handleLoadAuditLogs(draft, action.auditLog);
        return;
      }
      case RESET_AUDIT_LOGS: {
        if (draft.applicationDetailData) {
          draft.applicationDetailData.dateAuditLog = undefined;
        }
        return;
      }
      case SET_NOTIFY_WORK_COMPLETION_SUCCESS: {
        handleNotifyWorkCompletion(draft, action.updatedInfo);
        return;
      }
      case REMOVE_PARTICIPANT_SUCCESS: {
        draft.applicationDetailData!.participants = draft.applicationDetailData!.participants!.filter(
          x => x.participantLinkId !== action.participantLinkId
        );
        return;
      }
      case SET_LOCATION_SUCCESS: {
        handleLocationUpdate(draft, action.locationInfo);
        return;
      }
      case DELETE_ATTACHMENT_SUCCESS: {
        handleDeleteAttachment(draft, action.attachmentReference);
        return;
      }
      case CANCEL_APPLICATION_SUCCESS: {
        if (draft.applicationDetailData) {
          draft.applicationDetailData.isApplicationCancelled = true;
        }
        return;
      }
      case SET_MAINTENANCE_COMPLETION_SUCCESS: {
        handleMaintenanceCompletion(draft, action.model);
        return;
      }
      case DECLINE_APPLICATION_PARTICIPANT_SUCCESS: {
        draft.participantDeclined = true;
        return;
      }
      case SET_TTM_STANDARD_SUCCESS: {
        if (draft.applicationDetailData) {
          draft.applicationDetailData.ttmStandard = action.ttmStandard;
        }
        return;
      }
    }
  },
  initialState
);

export default applicationDetailReducer;
